export default __webpack_public_path__ + "static/media/pomerania-employers-banner-desktop.03e9b4c2.jpg";